// extracted by mini-css-extract-plugin
module.exports = {"root":"ParticipantsPage_root__2HjgB","submitButton":"ParticipantsPage_submitButton__10x0Y","titleRow":"ParticipantsPage_titleRow__1mdon"};